import React from "react";
import { usePermissions } from "@/hooks/use-permissions";

interface PermissionGuardProps {
  children: React.ReactNode;
  permissionCode?: string;
  featureCode?: string;
  permissionType?: "CREATE" | "UPDATE" | "VIEW" | "DELETE";
  permissionCodes?: readonly string[];
  requireAll?: boolean;
  fallback?: React.ReactNode;
}

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  children,
  permissionCode,
  featureCode,
  permissionType,
  permissionCodes,
  requireAll = false,
  fallback = null,
}) => {
  const {
    hasPermission,
    hasFeaturePermission,
    hasAnyPermission,
    hasAllPermissions,
  } = usePermissions();

  let hasAccess = false;

  // Check specific permission code
  if (permissionCode) {
    hasAccess = hasPermission(permissionCode);
  }
  // Check feature permission
  else if (featureCode && permissionType) {
    hasAccess = hasFeaturePermission(featureCode, permissionType);
  }
  // Check multiple permission codes
  else if (permissionCodes && permissionCodes.length > 0) {
    hasAccess = requireAll
      ? hasAllPermissions([...permissionCodes])
      : hasAnyPermission([...permissionCodes]);
  }
  // If no conditions specified, show content
  else {
    hasAccess = true;
  }

  if (hasAccess) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};
